<template>
    <div class="cell small-12 medium-6 large-4" v-if="filters[filter_name]" >
        <div class="o-vacancies-filters__select-filter" :class="{ 'active' : isActiveFilter( filter_name ), 'active open' : openFilter }">
            <span class="o-vacancies-filters__select-wrapper">
                <span v-html="selectLabel"></span>
                <div class="o-vacancies-filters__select-toggle" @click="toggleOpenFilter()">
                    <i class="c-icon icon-arrow-down-c"></i>
                </div>
            </span>
            <ul class="o-vacancies-filters__select-options" data-filter="filter_name">
                <li v-for="(item, item_key) in filters[filter_name]" :key="item_key" class="c-vacancies-filter-option" :class="{ 'active' : isActiveFilterOption( filter_name, item.term_id ) }" @click="toggleFilters( filter_name, item.term_id )" v-html="item.name"></li>
            </ul>
        </div>
    </div>
</template>

<script>
    import vacanciesMixin from "../../../mixins/vacancies";

    export default {
        name: 'TaxonomyFilter',
        props: ['filters', 'filter_name'],
        mixins: [vacanciesMixin],
        computed: {
            selectLabel(){
                let vm = this,
                    label = '';

                if( vm.activeFilters[vm.filter_name].type == 'multiple' && vm.activeFilters[vm.filter_name].value?.length > 0) {
                    vm.filters[vm.filter_name].forEach((filter_option) => {
                        if ( vm.activeFilters[vm.filter_name].value.indexOf(filter_option.term_id) !== -1 ) {
                            if( label !== '' ) label += ', ';
                            label += filter_option.name;
                        }
                    });
                } else if( vm.activeFilters[vm.filter_name].type == 'single' && vm.activeFilters[vm.filter_name].value !== null ) {
                    vm.filters[vm.filter_name].forEach((filter_option) => {
                        if( filter_option.term_id === vm.activeFilters[vm.filter_name].value ) {
                            label = filter_option.name;
                        }
                    });
                } else {
                    label = vm.$t("vacancies." + vm.filter_name);
                }

                return label;
            }
        },
        data() {
            return {
                openFilter: false
            }
        }
    }
</script>